import { Form, Input } from 'antd';
import React from 'react';
import { useAppSelector } from '../../../../hooks/store';
import { getIsMobile } from '../../../../redux/selectors';
import { ButtonLink } from '../../../../components/base/Button/Link';
import { getCommonRoutePath } from '../../../../helpers/Helpers';
export var SingInFormItems = function () {
    var isMobile = useAppSelector(getIsMobile);
    return (React.createElement(React.Fragment, null,
        React.createElement(Form.Item, { name: "email", label: isMobile ? null : 'Email', rules: [
                {
                    required: true,
                    message: 'Please enter your email address',
                },
                function (_a) {
                    var getFieldValue = _a.getFieldValue;
                    return ({
                        validator: function () {
                            var emailValue = getFieldValue('email');
                            if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,16}$/i.test(emailValue)) {
                                return Promise.reject(new Error('Invalid email address'));
                            }
                            return Promise.resolve();
                        },
                    });
                },
            ] },
            React.createElement(Input, { placeholder: "Email", type: "email" })),
        React.createElement(Form.Item, { name: "password", label: isMobile ? null : 'Password', rules: [
                {
                    required: true,
                    message: 'Please enter your new password',
                },
            ] },
            React.createElement(Input.Password, { type: 'password', placeholder: "Password" })),
        React.createElement(ButtonLink, { ghost: true, type: "link", className: 'text-right p-0 text-natural-active h-auto w-full', to: "".concat(getCommonRoutePath(), "/community/recover-password") }, "Forgot password?")));
};
